import type { Plan } from "./database.types";

// Web mirror of apps/api/src/plans.ts. Prices MUST match the API (the smoke test
// pins them). The billing view reads the computed invoice from GET /api/billing
// so totals have one source of truth; these constants drive the upgrade modal's
// tier cards (price + feature bullets) and any client-side price label.

export const PLAN_PRICE_MXN: Record<Plan, number> = {
  free: 0,
  pro: 799,
  enterprise: 2999,
};

// Format an MXN amount the Mexican way: $1,234 (no cents — plans are whole pesos).
export function mxn(amount: number): string {
  return `$${amount.toLocaleString("es-MX")}`;
}

export const PLAN_ORDER: Plan[] = ["free", "pro", "enterprise"];

interface PlanCopy {
  name: string;
  // Short price suffix, e.g. "MXN/mes". Free has none.
  suffix: string;
  features: string[];
}

// Bilingual tier copy for the upgrade modal. Feature bullets track the
// docs/BUILD-PLAN.md tier table (personas/queries, engines, cadence, delivery).
export const PLAN_COPY: Record<"es" | "en", Record<Plan, PlanCopy>> = {
  es: {
    free: {
      name: "Gratis",
      suffix: "para siempre",
      features: [
        "1 perfil · 1 consulta",
        "Solo ChatGPT",
        "Reporte mensual",
        "Descarga de archivos",
      ],
    },
    pro: {
      name: "Pro",
      suffix: "MXN/mes",
      features: [
        "3 perfiles · 10 consultas",
        "Todas las IA + búsqueda",
        "Reportes semanales",
        "Descarga + MCP · prueba 30 días",
      ],
    },
    enterprise: {
      name: "Enterprise",
      suffix: "MXN/mes",
      features: [
        "10 perfiles · 50 consultas",
        "Todas las IA + AI Overviews",
        "Reportes semanales",
        "Descarga + MCP + API",
      ],
    },
  },
  en: {
    free: {
      name: "Free",
      suffix: "forever",
      features: [
        "1 persona · 1 query",
        "ChatGPT only",
        "Monthly report",
        "File downloads",
      ],
    },
    pro: {
      name: "Pro",
      suffix: "MXN/mo",
      features: [
        "3 personas · 10 queries",
        "All AIs + search",
        "Weekly reports",
        "Download + MCP · 30-day trial",
      ],
    },
    enterprise: {
      name: "Enterprise",
      suffix: "MXN/mo",
      features: [
        "10 personas · 50 queries",
        "All AIs + AI Overviews",
        "Weekly reports",
        "Download + MCP + API",
      ],
    },
  },
};
